module.exports = {
      id: "eat-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/poi.svg#eat-usage",
      toString: function () {
        return this.url;
      }
    }